module.exports = __webpack_public_path__ + "static/media/rejected.57872386.svg";